module.exports = __webpack_public_path__ + "static/media/facebook.310b307f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/facebook.svg
// module id = 218
// module chunks = 0